var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLiCrSent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4131 5.92391L19.8751 3.46195M19.8751 3.46195L17.4131 1M19.8751 3.46195L14.9512 3.46195",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93583 12.4917C7.57144 12.4619 6.21484 12.7048 4.94557 13.2062C3.6763 13.7076 2.51991 14.4574 1.54422 15.4116C1.17739 15.794 0.994387 15.986 1.00013 16.2429C1.01394 16.3597 1.05376 16.472 1.11668 16.5714C1.17959 16.6708 1.264 16.7549 1.36368 16.8174C1.78688 16.9817 2.24475 17.0365 2.69478 16.9766H15.1769C15.6269 17.0365 16.0848 16.9817 16.508 16.8174C16.6077 16.7549 16.6921 16.6708 16.755 16.5714C16.8179 16.472 16.8577 16.3597 16.8715 16.2429C16.8773 15.9844 16.6943 15.7932 16.3274 15.4116C15.3517 14.4574 14.1954 13.7076 12.9261 13.2062C11.6568 12.7048 10.3002 12.4619 8.93583 12.4917Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2295 8.4341C9.88341 8.4341 10.5226 8.2402 11.0664 7.87693C11.6101 7.51365 12.0339 6.99731 12.2841 6.39319C12.5344 5.78907 12.5999 5.12431 12.4724 4.48295C12.3449 3.84159 12.0301 3.25245 11.5678 2.79C11.1054 2.32756 10.5164 2.01259 9.87505 1.88492C9.23372 1.75725 8.56894 1.82261 7.96476 2.07274C7.36058 2.32287 6.84414 2.74653 6.48072 3.29016C6.11731 3.83379 5.92326 4.47296 5.9231 5.12687C5.92299 5.56115 6.00843 5.99119 6.17455 6.39243C6.34066 6.79368 6.58419 7.15827 6.89123 7.46539C7.19827 7.7725 7.5628 8.01612 7.964 8.18234C8.36521 8.34855 8.79523 8.4341 9.2295 8.4341Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLiCrSent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/liCrSent.b682ba82.svg";
export { ForwardRef as ReactComponent };